export const STICKY_FOOTER_HEIGHT = 75
